import { Controller } from "@hotwired/stimulus"

// The optional cost sections of the calculation drawer (Geräte, Fremdleistung, Sonstiges).
// Empty, each would be a whole box holding nothing but "+ Zeile hinzufügen"; instead they
// render hidden behind one compact row of add buttons. Clicking one reveals its section
// and adds the first row through the section's own nested-form link, so the new row gets
// the usual treatment (template, focus).
export default class extends Controller {
  static targets = ["section", "adder", "adders"]

  reveal({ currentTarget, params: { type } }) {
    const section = this.sectionTargets.find((element) => element.dataset.costType === type)
    if (!section) return

    section.classList.remove("hidden")
    currentTarget.remove()
    if (!this.hasAdderTarget) this.addersTarget.classList.add("hidden")

    section.querySelector("[data-action~='click->nested-form#add_association']")?.click()
  }
}
